module.exports = (variables, { tpl }) => {
    const view = variables.componentName.replace(/^([A-Z][a-z]*).*/, '$1');
    return tpl`
import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const ${variables.componentName} = hoc(
    (props: IconProps) => (
        ${variables.jsx}
    ),
    '${view}'
);

${variables.exports};
`;
};
